import React, { useEffect } from "react";
import MainWindow from "../components/MainWindow";
import ThemeConfigDrawer from "../components/ThemeConfigDrawer";
import ErrorBoundary from "../components/ErrorBoundary";
import { styled } from "@mui/system";
import Header from "../components/Header";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { affiliateId, authSessionid, authUsername, editor, user } from "../slices/auth-slice";
import { useNavigate } from "react-router-dom";
import { affiliate, affiliateName } from "../slices/affiliateTheme";
import { request } from "http";

const AppRoot = styled("div")({
  display: "flex",
  height: "100vh",
});

const HeaderNavAndMain = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
});

const NavAndMain = styled("div")({
  flex: 1,
  display: "flex",
  minHeight: 0,
});

const Main = styled("main")({
  minWidth: 0,
  minHeight: 0,
  flex: 1,
  display: "flex",
  flexDirection: "column",
});

export default function User() {
  const dispatch = useAppDispatch();
  const affiliateIdData = useAppSelector(affiliateId);
  const affiliateNameData = useAppSelector(affiliateName);
  const sessionId = useAppSelector(authSessionid);
  const userName = useAppSelector(authUsername);

  useEffect(() => {
    const request = {
      sessionid: sessionId,
      username: userName,
      request: {
        affiliateid: affiliateIdData,
      }
    };
    dispatch(affiliate(request)).unwrap();
  }, []);

  return (
    <AppRoot>
      <ErrorBoundary>
        <HeaderNavAndMain className="header">
          <Header affiliateName={affiliateNameData} />
          <NavAndMain>
            <Main>
              <MainWindow /> {/* body */}
            </Main>
          </NavAndMain>
        </HeaderNavAndMain>
        <ThemeConfigDrawer />
      </ErrorBoundary>
    </AppRoot>
  );
}
